export default __webpack_public_path__ + "static/24-body-modification-591e2aa5d9807ecbac0f20faf9e75a6a.png";